import { useGetTransportPositionQuery } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { LatLngTuple } from 'leaflet';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Marker } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { TRANSPORT_POSITION_POLLING_INTERVAL } from 'utils/constants';
import { createTransportMarker } from '../../../../components/MarkerIcon/MarkerIcon';
import { useMapSlice } from '../../slice';
import { selectHiddenOnMapGpsVehicleIds } from '../../slice/selectors';

interface IProps {}

const TransportMarkers: FC<IProps> = props => {
  const dispatch = useDispatch();
  const mapActions = useMapSlice().actions;
  const { t } = useTranslation();

  const seasonId = useSelector(selectSelectedSeasonId) as number;
  const envId = useSelector(selectSelectedEnvId) as number;
  const hiddenTransportIds = useSelector(selectHiddenOnMapGpsVehicleIds);
  const [isTransport403, setIsTransport403] = useState(false);

  const {
    data: transportResponse,
    error: transportError,
  } = useGetTransportPositionQuery(
    {
      seasonId,
      envId,
    },
    {
      pollingInterval: TRANSPORT_POSITION_POLLING_INTERVAL,
      skip: isTransport403,
    },
  );

  useEffect(() => {
    if (
      transportError &&
      'status' in transportError &&
      transportError?.status === 403
    ) {
      setIsTransport403(true);
    }
  }, [transportError]);

  useEffect(() => {
    setIsTransport403(false);
  }, [envId]);

  const filteredTransport = transportResponse?.features.filter(
    tranport =>
      !hiddenTransportIds.includes(tranport.properties.gps_vehicle_id),
  );

  const onClick = (coordinates: LatLngTuple) => {
    dispatch(mapActions.setFitCoordArrOnMap([coordinates]));
  };

  return (
    <>
      {filteredTransport?.map(transport => (
        <Marker
          key={transport.properties.gps_vehicle_id}
          position={[
            transport.geometry.coordinates[1],
            transport.geometry.coordinates[0],
          ]}
          eventHandlers={{
            click() {
              onClick([
                transport.geometry.coordinates[1],
                transport.geometry.coordinates[0],
              ]);
            },
          }}
          icon={createTransportMarker({
            ignitionOn: transport.properties.ignition_on,
            name:
              transport.properties.model || transport.properties.license_plate,
            workerName:
              transport.properties.first_name && transport.properties.last_name
                ? `${transport.properties.first_name} ${transport.properties.last_name}`
                : '',
            workerPhoneNumber: transport.properties.phone_number,
            implement: transport.properties.implement_model,
            fuelLevel:
              transport.properties.fuel_level !== null
                ? `${t('Field.FuelLevel', 'Fuel level')} - ${
                    transport.properties.fuel_level
                  }`
                : '',
          })}
        />
      ))}
    </>
  );
};

export default TransportMarkers;
